const BLOCKED_TAGS = new Set([
  'script',
  'iframe',
  'object',
  'embed',
  'link',
  'meta',
  'base',
  'form',
  'input',
  'button',
  'textarea',
  'select',
  'option'
])

const URL_ATTRIBUTES = new Set(['href', 'src', 'xlink:href', 'action', 'formaction'])

const isDangerousUrl = (value) => {
  const normalized = String(value || '').trim().replace(/[\u0000-\u001F\u007F\s]+/g, '').toLowerCase()
  return normalized.startsWith('javascript:') || normalized.startsWith('vbscript:') || normalized.startsWith('data:text/html')
}

export const sanitizeHtml = (html = '') => {
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return ''
  }

  const parser = new DOMParser()
  const doc = parser.parseFromString(String(html), 'text/html')

  doc.body.querySelectorAll('*').forEach((node) => {
    const tagName = node.tagName.toLowerCase()
    if (BLOCKED_TAGS.has(tagName)) {
      node.remove()
      return
    }

    Array.from(node.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase()
      const value = attr.value

      if (name.startsWith('on') || name === 'style') {
        node.removeAttribute(attr.name)
        return
      }

      if (URL_ATTRIBUTES.has(name) && isDangerousUrl(value)) {
        node.removeAttribute(attr.name)
      }
    })
  })

  return doc.body.innerHTML
}
